class Modal extends HTMLElement {
  constructor() {
    super();

    this.triggers = document.querySelectorAll(".js-modal-trigger");
    this.modal = this.querySelector(".modal");
    this.close = this.querySelector(".modal__close");
    this.type = this.dataset.type;

    this.listeners();
  }

  listeners() {
    this.openModalEvent();
    this.closeModalEvent();
  }

  openModalEvent() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener("click", () => this.openModal(trigger));
      trigger.addEventListener("touchend", () => this.openModal(trigger));
    });
  }

  openModal(trigger) {
    const dataset = trigger.dataset;
    const index = dataset.index;
    const isTouch = window.matchMedia("(max-width: 989px)").matches;

    if (isTouch && this.triggerIsSliding(trigger)) return;

    if (this.type === dataset.type) this.modal.classList.add("modal--active");

    if (dataset.publishable && index > 1) {
      publish(PUB_SUB_EVENTS.sliderUpdate, {
        slide: index
      });
    }

    document.body.classList.add('overflow-hidden');
  }
  
  closeModalEvent() {
    this.close.addEventListener("click", () => {
      this.modal.classList.remove("modal--active");

      document.body.classList.remove('overflow-hidden');
    });

    this.addEventListener("click", event => {
      if (event.target === this.modal) this.modal.classList.remove("modal--active");

      document.body.classList.remove('overflow-hidden');
    });
  }

  triggerIsSliding(trigger) {
    if (this.type === 'product') {
      const carousel = trigger.closest("slideshow-component");

      return carousel.dragging;
    }
  }
}

customElements.define("modal-component", Modal);
